import React from 'react';
import PropTypes from 'prop-types';
import uikit from '../../../../project/uikit/styles';
import css from './Sums.module.scss';
import classnames from 'classnames';
import { generateGridStyles } from '../../components/helpers';

const Sums = ({ getHandlers, val, gridStyles, name }) => {
    const { stylers, classes, existCl, existSt } = generateGridStyles(gridStyles, name);
    return (
        <div {...getHandlers(false)} className={existCl('wrapper') || classnames(css.flexColumn)}>
            <p className={classes.count} style={{ ...uikit.noWrap, ...existSt('count') }}>
                {val.currencySymbol} {val.currencySum}
            </p>
            {val.pvSum ? (
                <p className={classnames(css.dimentions || {}, classes.dimentions)} style={stylers.dimentions}>
                    {val.pvSum}
                </p>
            ) : null}
        </div>
    );
};
Sums.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string]),
    styles: PropTypes.object,
    name: PropTypes.string
};
export default Sums;
